<template>
  
  
  <div class="mapcontiner" > 
    <div class="vegelist" style="height:9vh;padding:0.5vh;display:flex;flex-direction: column;margin-top:2vh;position: relative;">
        <div class="vegetype" >
          <div class="typeitem"  v-for="(item,index) in vegetype" @click="clickvetype(index)"  :class="{typeitem_active:index==typeid}" >{{item}}</div>
        </div>
        <div class="vegedata" >
          <div class="vedaitem" v-for="(item,index) in vegeitems"  @click="clickvegetable(item)">
            {{item}}
            <div :class="{vedaitem_active:activevegetable==item}"></div>  
          </div>
        </div>
        
    </div>
     <!-- <div class="vegelist" style="width:200px" >
      <el-input v-model="searchVeg" placeholder="搜索蔬菜" @input="handleSearchv" ></el-input>
      <div class="vege_item">
        <el-menu
          class="el-menu-vertical-demo"
          @select="handleSelectv"
        >
          <el-menu-item v-for="(item, index) in filteredVegetable" :index="index">
            <template slot="title">
              {{ item }}
            </template>
          </el-menu-item>
        </el-menu>
      </div> 
     </div> -->
     <div class="rightdata"  v-loading="loading">
        
        <div class="leftbar">
          <div class="maptitle">
            <span >{{activevegetable}}全国平均单位面积/产量碳足迹</span>
          </div>
          <div  class="bardemo"  ref="chartsDOMbar" v-if="ifdata"></div>
          <div ><div v-if="ifdata==false" class="nodata" >暂无数据</div></div>
          
        </div>
        
        <div class="mapmap" >
          <div class="maptitle">
            <span >{{activevegetable}}各省单位</span>
            <div @click="isarea=!isarea,changearea()">
              <span v-if="isarea==true" class="text_isarea"   style="color:#77cef6"> 面积</span>
              <span class="text_isarea"  style="color:#f99354" v-else > 产量</span><span>碳足迹</span>
              <span class="text_isarea"><img style="width:2vh;height:2vh;margin-left:1vh;" src="../assets/switch.png"></span>
            </div>
          </div>
          <div class="mapdemo"  ref="chartsDOMmap" v-if="ifdata"></div>
          <div ><div v-if="ifdata==false" class="nodata" >暂无数据</div></div>
          
        </div>
     </div>

     
    
  </div>
     
 
</template>

<script>

import china from '@/assets/china.js'
import * as echarts from 'echarts'
import chinadata from '@/assets/china2.json'
import router from '@/router';
export default {
  name:'ChinaMap',
  data(){
    return{
      ifdata:true,
      searchVeg:'',
      searchPro:'',
      dialogTableVisible:false,
      viewportHeight:0,
      timerflag:false,
      routerlock:false,
      loading:true,
      myChartbar:null,
        optionbar:null,
        seriesData:[],
        timeData:[],
        minarea:0,
        minyield:0,
        maxarea:0,
        maxyield:0,
      mapsize:[],
      typeid:0,
      // vegetype:['主粮','蔬菜','林果','糖料','油料','烟叶','纤维','大豆','茶'],
      vegetype:['主粮','蔬菜','林果','糖料','油料','烟叶','纤维','大豆'],
      vegetypeitem: [
      ['小麦','玉米','水稻-早籼稻','水稻-中籼稻','水稻-晚籼稻','水稻-粳稻'],
      ["马铃薯","菜花", "大白菜", "豆角", "露地菜椒", "露地黄瓜", "露地茄子", "露地西红柿", "萝卜", "设施菜椒", "设施黄瓜", "设施茄子", "设施西红柿", "圆白菜"],
      ['苹果','柑','橘'],
      ['甘蔗','甜菜'],
      ['花生','油菜'],
      ['烤烟','晾晒烟'],
      ['桑蚕丝','棉花'],
      ['大豆']
      ],
      //['绿茶','乌龙茶']
      vegeitems:['小麦','玉米','水稻-早籼稻','水稻-中籼稻','水稻-晚籼稻','水稻-粳稻'],
      vegetableList:[' 小麦','豆角','菜花','大白菜'],
      // filteredVegetable:[],
      activeIndexv: 0,
      activevegetable:"小麦",
      activevegetype:"主粮",      
      allprovincesData:[],
      nationData:[],
      message: 'Hello, Vue!',
      myChart: null,
      option:[],
      chinadata,
      playtime: 0, // 用于记录当前轮播到的份索引
      timer: null, // 用于轮播的定时器
      provincesList:['北京', '天津', '河北', '山西', '内蒙古', '辽宁', '吉林', '黑龙江', '上海', '江苏', '浙江', '安徽', '福建', '江西', '山东', '河南', '湖北', '湖南', '广东', '广西壮族', '海南', '重庆', '四川', '贵州', '云南', '西藏', '陕西', '甘肃', '青海', '宁夏回族', '新疆维吾尔'],
      activetime:2004,
      isarea:true,
    };
  },
  mounted(){
    this.ifdata=true
    console.log(this.ifdata)
    this.getprovice()
    this.viewportHeight=window.innerHeight
    // this.getvegetable()
  },
  
  beforeDestroy() {
    clearInterval(this.timer); // 在组件销毁时清除定时器
  },
  methods:{
    clickvegetable(item){
      this.activevegetable=item
       if(this.timerflag==true){
            clearInterval(this.timer); // 暂停轮播，清除定时器
            this.timerflag=false
          }
      this.playtime=0
      this.getprovice()
    },
    clickvetype(index){
      this.typeid=index
      this.vegeitems=this.vegetypeitem[index]
      this.activevegetype=this.vegetype[index]
      this.clickvegetable(this.vegeitems[0])
    },
    getprovice(){
      this.ifdata=true
      this.loading=true
      this.$axios.get('/api/getdatabytv/?type='+this.activevegetype+'&&vege='+this.activevegetable).then(res=>{
				console.log(res.data);
        this.allprovincesData=res.data
        console.log(typeof this.allprovincesData)
        this.initbar();
        this.initChartmap();
        
        if(this.timerflag==false){
            this.startAutoPlay(); // 继续轮播，调用继续轮播的函数
            this.timerflag=true
          }
        
        this.loading=false
			})
      .catch(error => {
        
        
          if (error.response && error.response.status === 505) {
            this.ifdata=false
            console.log(this.ifdata)
            console.log('获取数据错误');
            this.error = '错误：未找到相关数据';
          } else {
            this.error = '请求出错，请稍后重试';
            console.error(error);
          }
          this.loading = false;
        });
    },
    initbar(){
      this.nationData=this.allprovincesData.map(item=>{
          return{
            time:item.time,
            area:item.area,
            yield:item.yield
          }
        })
      console.log(this.nationData)
      this.timeData=this.nationData.map(item=>item.time)
      console.log(this.timeData)
      var areaData=this.nationData.map(item=>item.area.toFixed(3))
      // this.minarea=Math.min(...areaData)
      this.minarea=0
      this.maxarea=Math.max(...areaData)
      console.log(this.minarea)
      var yieldData=this.nationData.map(item=>item.yield.toFixed(3))
      // this.minyield=Math.min(...yieldData)
      this.minyield=0
      this.maxyield=Math.max(...yieldData)
      this.seriesData=[]
      this.seriesData.push({name:'单位面积碳足迹',type:'bar',data:areaData,yAxisIndex: 0,color:'#99cae1'})
      this.seriesData.push({name:'单位产量碳足迹',type:'line',data:yieldData,yAxisIndex: 1,color:'#f99354'})
      this.initChartbar()
    },
    changeoption(provicesData,time){
      if(this.isarea){
        let a1=provicesData.map(item => {
                          return {
                              name:item.name,
                              area:item.area.toFixed(3),
                              yield:item.yield.toFixed(3),
                              value:item.area.toFixed(3)
                          };})

        var mapmin=Math.min(...a1.map(item=>item.area))
        var mapmax=Math.max(...a1.map(item=>item.area))
        var datamin=Math.floor(mapmin-(mapmax-mapmin)/5)
        this.option.visualMap.min=datamin>0?datamin:0
        this.option.visualMap.max=Math.floor(mapmax+(mapmax-mapmin)/5)
        this.activetime=time
         this.option.title.text=time
        this.option.series[0].data=a1
        this.myChart.setOption(this.option);}
      else{
        let a1=provicesData.map(item => {
                          return {
                              name:item.name,
                              area:item.area.toFixed(3),
                              yield:item.yield.toFixed(3),
                              value:item.yield.toFixed(3)
                          };})
        
        var mapmin=Math.min(...a1.map(item=>item.yield))
        var mapmax=Math.max(...a1.map(item=>item.yield))
        this.option.visualMap.min=0
        this.option.visualMap.max=1
        this.activetime=time
        this.option.title.text=time
        this.option.series[0].data=a1
        this.myChart.setOption(this.option);}
       
    },
    initChartbar(){
      let that=this
        this.myChartbar = echarts.init(this.$refs["chartsDOMbar"]);
      // 显示 loading 动画
        this.myChartbar.showLoading();
      // 再得到数据的基础上，进行地图绘制
        this.myChartbar.hideLoading();
        this.optionbar = {
          
          
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            position: function (pt) {
               return [130,pt[1]];
            },
            formatter: function (params) {
    
                const itemData = params

                if(itemData.length==2)
                  return `${itemData[0].axisValue}<br>单位面积碳足迹：${itemData[0].data} t CO<sub>2</sub>e/hm<sup>2</sup><br>单位产量碳足迹：${itemData[1].data} kg CO<sub>2</sub>e/kg`;
                else {
                  if (itemData[0].seriesName=="单位面积碳足迹")
                  return `${itemData[0].axisValue}<br>${itemData[0].seriesName}：${itemData[0].data} t CO<sub>2</sub>e/hm<sup>2</sup>`;
                  else
                  return `${itemData[0].axisValue}<br>${itemData[0].seriesName}：${itemData[0].data} kg CO<sub>2</sub>e/kg`;
                }
            }
            
          },
          legend: [
                // 左侧 legend
                {
                    data: ['单位面积碳足迹'],
                    left: 10,
                    align: 'left'
                },
                // 右侧 legend
                {
                    data: ['单位产量碳足迹'],
                    right: 0,
                    align: 'left'
                }
            ],
          // legend: {

          // width: '100%',
          // data: ['单位面积碳足迹','单位产量碳足迹'],  // 设置legend显示的内容 area
          // left: 'left',  // 设置legend整体向左偏移 
          // selectedMode: true 
          // },
          grid: {
            // top:'10%',
            // left: '5%',
            // right: '10%',
            // bottom: '5%',
            // containLabel: true
          },
          yAxis: [{
            type: 'value',
            name:'t CO{sub|2}e/hm{sup|2}',
            position:'left',
            nameTextStyle:{
                rich:{
                    sub: {
                    verticalAlign: "bottom",
                    fontSize: 8
                    },
                    sup:{
                    verticalAlign: "top",
                    fontSize: 8
                    }
                }
              },
            //min:(this.minarea-(this.maxarea-this.minarea)/10).toFixed(2)
            min:0
          },{
            type: 'value',
            name:'kg CO{sub|2}e/kg',
            position:'right',
            nameTextStyle:{
                rich:{
                    sub: {
                    verticalAlign: "bottom",
                    fontSize: 8
                    },
                    sup:{
                    verticalAlign: "top",
                    fontSize: 8
                    }
                }
              },
           // min:(this.minyield-(this.maxyield-this.minyield)/10).toFixed(2)
            min:0
          }],
          xAxis: {
            type: 'category',
            data: this.timeData
          },
          series:this.seriesData
        };
        this.myChartbar.setOption(this.optionbar);
        this.myChartbar.on('mousemove', function (params) {
           
           
          if(that.timerflag==true){
            clearInterval(that.timer); // 暂停轮播，清除定时器
            that.timerflag=false
          }
          
          that.playtime=params.dataIndex
          that.changeoption(that.allprovincesData[that.playtime].data,that.allprovincesData[that.playtime].time)
      
           
        });
        this.myChartbar.on('globalout', function () {
           
          if(that.timerflag==false){
            that.startAutoPlay(); // 继续轮播，调用继续轮播的函数
            that.timerflag=true
          }
           
           
        });
    },
    changearea(){
      if(this.ifdata){
        console.log(this.isarea)
        if(this.isarea){
          this.changeoption(this.allprovincesData[this.playtime].data,this.allprovincesData[this.playtime].time)
        }
        else{
          var provicesData=this.allprovincesData[this.playtime].data 
          let a1=provicesData.map(item => {
                            return {
                                name:item.name,
                                area:item.area.toFixed(3),
                                yield:item.yield.toFixed(3),
                                value:item.yield.toFixed(3)
                            };})
          var mapmin=Math.min(...a1.map(item=>item.yield))
          var mapmax=Math.max(...a1.map(item=>item.yield))
          this.option.visualMap.min=0
          this.option.visualMap.max=1
          this.option.series[0].data=a1
          this.myChart.setOption(this.option);
        }
      }
      else{
        clearInterval(this.timer)
      }
      
      
    },
    initChartmap(){
      let that=this
      // 初始化统计图对象
      this.myChart = echarts.init(this.$refs["chartsDOMmap"]);
      // 显示 loading 动画
      this.myChart.showLoading();
      // 再得到数据的基础上，进行地图绘制
      this.myChart.hideLoading();
        // 注册地图(数据放在axios返回对象的data中哦)
      echarts.registerMap('China', chinadata);
    
        this.option = {
          title: {
             text: this.activetime,
            //   subtext: 'Data from www.census.gov',//链接名
            //sublink: 'xxx',//链接
            left: 'center',
            top: (0.1*this.viewportHeight),
            textStyle: {
              fontSize: (0.03*this.viewportHeight)
            }
          },

          visualMap: {
              left: 'right',
              min: 0.0,
              max: 1.0,
              inRange: {
                color: [
                  '#313695',
                  '#4575b4',
                  '#74add1',
                  '#abd9e9',
                  '#e0f3f8',
                  '#ffffbf',
                  '#fee090',
                  '#fdae61',
                  '#f46d43',
                  '#d73027',
                  '#a50026'
                ]
              },
              text: ['High', 'Low'],
              type: 'continuous',
              calculable: true
          },
          toolbox: {
            show: true,
            //orient: 'vertical',
            left: 'left',
            top: 'top',
            feature: {
              // dataView: { readOnly: false },
              restore: {},
              saveAsImage: {}
            }
          },
          // tooltip:{},
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              console.log(params)
                const itemData = params.data;
                if(itemData!=null)
                  return `${itemData.name}<br>单位面积碳足迹：${itemData.area} t CO<sub>2</sub>e/hm<sup>2</sup><br>单位产量碳足迹：${itemData.yield} kg CO<sub>2</sub>e/kg`;
                else return `${params.name}`;
            }
          },
          series: [
            {
              bottom:'10%',
              top:'10%',
              zoom:1.1,//默认缩放大小
              name: '中国地图',
              type: 'map',
              map: 'China',
              label: {
                  show: true,//各名
                  fontSize:11
              },
              //鼠标缩放大小
              roam: true,
              scaleLimit:{//放大缩小限制
                  min: 0.5,
                  max: 5
              },
              selectedMode: false,
              // data:a1,
              itemStyle: {
                      //鼠标悬停时，显示强调效果
                      emphasis: {
                              shadowBlur: 20,
                              shadowOffsetX: 7,
                              shadowColor: 'rgba(0, 0, 0, 0.6)'
                      },
                      shadowBlur: 10,
                        shadowColor: 'rgba(0, 0, 0, 0.5)',
                        shadowOffsetX: 3,
                        shadowOffsetY: 3
                  },
            }
          ]
        };
        this.changeoption(this.allprovincesData[0].data,this.allprovincesData[0].time)
        this.myChart.on('click', function(params){
              // 当鼠标点击事件触发时，在控制台输出params
              console.log(params);
              if(that.routerlock==false&&params.data){
                that.routerlock=true
                that.$router.push({path:'/data',query:{provicesdata:params.data.name,vegetable:that.activevegetable,vegetype:that.activevegetype}}).catch((error) => {
                    if (error.name!== 'NavigationDuplicated') {
                        console.log(error);
                    }
                });
                that.routerlock=false
              }else{
                 that.$message({
                   showClose: true,
                    message: '暂无该省份数据。',
                    type: 'warning',
                     center: true
                  });
              }
          })
        this.myChart.on('mouseover', function () {
          
           
          if(that.timerflag==true){
            clearInterval(that.timer); // 暂停轮播，清除定时器
            that.timerflag=false
          } // 暂停轮播，清除定时器
           
        });
        this.myChart.on('globalout', function () {

          if(that.timerflag==false){
            that.startAutoPlay(); // 继续轮播，调用继续轮播的函数
            that.timerflag=true
          }
          
        });
      },
      startAutoPlay(){
        let that=this
         this.timer = setInterval(() => {
          // 取消之前高亮的图形
          this.myChartbar.dispatchAction({
            type: 'downplay',
            seriesIndex:0, // 切换选中状态到对应份
             dataIndex: this.playtime
          });
          this.playtime = (this.playtime + 1) % this.allprovincesData.length;
          this.changeoption(this.allprovincesData[this.playtime].data,this.allprovincesData[this.playtime].time)
          this.myChartbar.dispatchAction({
            type: 'highlight',
            seriesIndex:0, // 切换选中状态到对应份
             dataIndex: this.playtime
          });
          this.myChartbar.dispatchAction({
            type: 'showTip',
            seriesIndex:0, // 切换选中状态到对应份
             dataIndex: this.playtime
          });
          // this.playtime=(this.playtime+1)%this.allprovincesData.length
          
          // this.changeoption(this.allprovincesData[this.playtime].data,this.allprovincesData[this.playtime].time)
        }, 1000); // 每2秒切换一次，可根据需求调整时间间隔
      },
      
    // handleSelectv(key) {
    //   console.log(key);
    //   this.activevegetable = this.filteredVegetable[key];
    //   // this.linedata = this.allprovincesData[this.activeprovince].data;
    //   console.log(this.activevegetable)
    //    clearInterval(this.timer);
    //    this.playtime=0
    //   this.getprovice()
    // },
    // handleSearchv() {
    //   // 根据搜索框输入内容过滤省份列表

    //   this.filteredVegetable = this.vegetableList.filter(vegetable =>
    //     vegetable.includes(this.searchVeg)
    //   );
       
    //   // 查找匹配省份在原省份列表中的索引
    //   const matchIndex = this.vegetableList.findIndex(vegetable =>
    //     vegetable === this.searchVeg
    //   );
    //   if (matchIndex!== -1) {
    //     // 设置当前激活的菜单项索引，用于滚动条定位
    //     this.activeIndexv = matchIndex.toString();
    //     // 获取el-menu实例
    //     const menu = this.$refs.menuRef;
    //     // 调用el-menu的滚动到指定索引的方法
    //     menu.setCurrentKey(this.activeIndexv);
    //   }
    // },
   
    
  }
  
}
</script>
<style>
.nodata{
  margin-top: 5vh;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mapdemo{
    width: 100%;
    height: 100%;
}
.bardemo{
  height: 100%;
  width: 100%;
}
.rightdata .mapmap{
  width: 56%;
    /* height: 60vh; */
}
.continer{
  /* display: flex; */
  height: 100%;
  width: 100%;
  
}
.leftbar{
  width: 45%;
  /* height: 60vh; */
}

.vege_item{
  height: 85%;
  overflow-y: auto;
}
.vege_item .el-menu-item {
display: flex !important;
justify-content: center;
align-items: center;
height: 4vh !important;
width: 18vh !important;
padding: 0 !important; 
}
.vege_item .el-menu {
  width: 18vh !important;
}
.rightdata{
  width: calc(100%-8vh) !important;
  display: flex;
  padding: 2vh 4vh;
  height: 60vh;
}
.mapcontiner{
  height: 83.4vh;
  width: 100vw;
  display: flex;
  background-color: #f0f0f4;
  flex-direction: column;
}
.typeitem:hover {
    cursor: pointer;
    background-color: #1d466b !important; /* 悬停时背景色变为白色 */
    color:  white !important; /* 悬停时字体颜色变为背景色 */
   
}

.typeitem_active{
  cursor: pointer;
    background-color: #1d466b !important; /* 悬停时背景色变为白色 */
    color:  white !important; /* 悬停时字体颜色变为背景色 */
    border-radius: 1.5vh; /* 添加圆角效果 */
}
.vegetype{
  font-size: 2vh;
  height:48%;
  display:flex;
  margin-bottom:0.4vh;
  margin-left:1vh;

}
.typeitem{
  font-size: 2vh;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 8vw;
  height: 4vh;
  padding-left:2vh;
  padding-right:2vh;
  padding-top:0.5vh;
  padding-bottom:0.5vh;
  margin-right:4vh;
  background-color: #f0f0f4;
  border-radius: 1.5vh;
  box-shadow: 0.2vh 0.2vh 0.5vh 0px rgba(0, 0, 0, 0.5); /* 主阴影 */
  transform: rotateY(10deg); /* 绕Y轴旋转10度 */
  transition: background 0.3s, color 0.3s; /* 平滑过渡效果 */
}
.vegedata{
  height:48%;
  display:flex;
  margin-left:4vh;
  margin-top:2vh
}
.vedaitem{
  padding: 0 1vh;
  font-size: 1.8vh;
  padding-top:0.5vh;
  padding-bottom:0.5vh;
  margin-right:3vh;
  cursor: pointer;
}
.vedaitem_active{
  margin-top: 0.5vh;
  border-radius: 0.5vh;
  height: 0.3vh;
  width: 100%;
  background-color: #1d466b;
 
}
.maptitle{
  display: flex;
  justify-content: center;
  align-items: center;
}
.maptitle span{
  font-size: 2.6vh;
  font-weight: 600;
}
.text_strong{
  font-size: 2.8vh !important;
  font-weight: 700 !important;
}
.text_isarea{
  font-size: 2.6vh;
  font-weight: 600;


  
}
.text_isarea:hover{
  font-size: 2.6vh;
  font-weight: 600;
  color: #77cef6;
}
</style>